import { FahrradWert } from '@ps20/bff-models';
import { IAppState } from '../../../store/appState';
import { ZUSATZOPTION_FAHRRAD_ID } from '../../../store/model/fahradwertForLinie.model';
import { selectSelectedProduktlinie } from './produkt.selector';

export const selectFahrradWertOfSelectedLinie = (state: IAppState): FahrradWert => {
  const selectedProduktlinie = selectSelectedProduktlinie(state);

  if (!selectedProduktlinie) {
    return null;
  }
  const zusatzoptionen = selectedProduktlinie.zusatzoptionen;
  let presettedSumValue = '';
  zusatzoptionen?.map(zo => {
    if (zo.id === ZUSATZOPTION_FAHRRAD_ID) {
      presettedSumValue = zo.eigenschaft;
    }
    return zo;
  });
  if (presettedSumValue) {
    return FahrradWert[presettedSumValue as keyof typeof FahrradWert];
  }

  const versicherungssummeFahrrad = state.versicherungssummeFahrrad.find(
    summeFahrrad => summeFahrrad.produktlinie === selectedProduktlinie.produktName,
  );

  if (versicherungssummeFahrrad) {
    return versicherungssummeFahrrad.summe;
  }
  throw new Error(
    `Keine versicherungssummeFahrrad für Linie ${selectedProduktlinie.produktName} gefunden!`,
  );
};

export const selectVersSumme = (state: IAppState): number =>
  Number(state.vertragsoptionen.versicherungssumme);
